import { render, staticRenderFns } from "./WorkspaceSidebar.vue?vue&type=template&id=848d6b24&scoped=true&"
import script from "./WorkspaceSidebar.vue?vue&type=script&lang=js&"
export * from "./WorkspaceSidebar.vue?vue&type=script&lang=js&"
import style0 from "./WorkspaceSidebar.vue?vue&type=style&index=0&id=848d6b24&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "848d6b24",
  null
  
)

export default component.exports